import React from 'react';
import PropTypes from 'prop-types';
import * as DOMPurify from 'dompurify';

import ArrowTooltip from './ArrowTooltip';
import LinkIcon from '../Common/SvgIcons/LinkIcon';

import htmlCleanser from '../../utils/htmlCleanser';
import { getSkillInformationLink } from '../../utils/skill';

import styles from './SkillTooltip.module.css';
import globalStyles from '../../globalStyles';

const sanitizer = DOMPurify.sanitize;

const TooltipContent = ({ identifier, description }) => {
  return (
    <div className={styles.skillDescribe}>
      <div
        className={styles.skillDes}
        dangerouslySetInnerHTML={{
          __html: htmlCleanser.removeTagsWithoutLink(sanitizer(description))
        }}
      ></div>
      <div className={styles.skillGroupWrapper}>
        <a
          className={styles.skillGroupLink}
          href={getSkillInformationLink(identifier)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Read more</span>
          <LinkIcon className={styles.skillGroupLinkIcon} />
        </a>
      </div>
    </div>
  );
};

TooltipContent.propTypes = {
  identifier: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  belongsTo: PropTypes.array,
  description: PropTypes.string
};

const useStylesTooltip = {
  '& .MuiTooltip-tooltip': {
    left: '-4px',
    color: `${globalStyles.white}`,
    backgroundColor: globalStyles.blue3,
    padding: '25px',
    minWidth: '400px',
    borderRadius: '2px'
  }
};

export const SkillTooltip = ({ children, ...props }) => {
  return (
    <ArrowTooltip
      arrow
      title={<TooltipContent {...props} />}
      interactive={'true'}
      leaveDelay={250}
      placement="bottom"
      classes={useStylesTooltip}
    >
      {children}
    </ArrowTooltip>
  );
};

SkillTooltip.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  belongsTo: PropTypes.array,
  description: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default SkillTooltip;
export { TooltipContent };
